
import { Button, TextField } from '@mui/material';
import React from 'react'
import RecordRTC from "recordrtc";
import { RealtimeTranscriber } from "assemblyai";
import { useEffect, useState, useRef } from "react"
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux'
import { generateReport } from "../actions/encodeActions"
import { RESET_GENERATED_PCR } from "../constants/encodeConstants"

let isRecording = false;
let recorder;
let rt;
let count;

const wordBoost = ['ambulance', 'IV', 'defibrillator', 'gauge', 'ectopies', 'ectopic,', 'ectopy', 'emergent'];

function RealtimeScreen() {
    const dispatch = useDispatch()

    const [isRecording, setIsRecording] = useState(null)
    const [label, setLabel] = useState('RECORD')
    const [connected, setConnected] = useState(false)
    const [transcription, setTranscription] = useState('')

    // editable and original Combined texts
    const [originalChartText, setOriginalChartText] = useState('')
    const [editableChartText, setEditableChartText] = useState('')
    const [editable, setEditable] = useState(true)

    const reportState = useSelector(state => state.reportReducer)
    const { reportError, chartLoading, chartText } = reportState

    useEffect(() => {
        if(chartText != null && chartText.Original != null && chartText.Original.Combined != null) {
            setOriginalChartText(chartText.Original.Combined)
            setEditableChartText(chartText.Original.Combined)
            dispatch({type: RESET_GENERATED_PCR})
            if (!isRecording) {
                setEditable(true)
            }
        }
    }, [chartText])

    const handleChartTextEditableChange = (e) => {
        setEditableChartText(e.target.value)
    }
    
    const handleStartButtonClick2 = (e) => {
        const recognition = new window.webkitSpeechRecognition();
        recognition.interimResults = true;
        recognition.lang = 'en-US';

        recognition.onresult = (event) => {
        const transcript = Array.from(event.results)
            .map(result => result[0].transcript)
            .join('');
        console.log('You said:', transcript);
        };

        recognition.start();
    }

    const handleStartButtonClick = async () => {
        if (isRecording) {
            // if (rt) {
            //     await rt.close(false);
            //     rt = null;
            // }
        
            if (recorder) {
                setLabel('STOPPING')
                await new Promise(r => setTimeout(r, 1000));
                recorder.stopRecording();
                recorder = null;
            }
            console.log('Stopped')
            setLabel('RECORD')
            // dispatch(generateReportRT(transcription, 1, 2))
        } else {
            // need to do a few things when a recording starts
            setLabel('WAIT...')
            setEditable(false)
            // check if the text has changed, so we can reclassify it

            const response = await axios.post(process.env.REACT_APP_GOLANGAPI + "/api/token");
            const texts = {};

            if (!connected) {
                rt = new RealtimeTranscriber({ token: response.data.token, wordBoost: wordBoost });
                rt.on("transcript", async (message) => {
                    console.log(JSON.stringify(message));

                    let msg = "";
                    texts[message.audio_start] = message.text;
                    const keys = Object.keys(texts);
                    keys.sort((a, b) => a - b);
                    for (const key of keys) {
                        if (texts[key]) {
                            msg += ` ${texts[key]}`;
                        }
                    }
                    setTranscription(msg);
                    var newCount = (msg.match(/\./g) || []).length
                    if (newCount != count) {
                        console.log('newCount: ' + newCount + ', count: ' + count)
                        count = newCount
                        dispatch(generateReport(msg, 1, 2))
                    }
                });

                rt.on("error", async (error) => {
                    console.error(error);
                    await rt.close();
                });
            
                rt.on("close", (event) => {
                    console.log(event);
                    rt = null;
                });
            
                console.log('Connecting...' + Date.now())
                setLabel('CONNECTING')
                await rt.connect(); 
                setConnected(true)
                count = 0  
            }

            console.log('Starting...' + Date.now())

            navigator.mediaDevices
                .getUserMedia({ audio: true })
                .then((stream) => {
                    recorder = new RecordRTC(stream, {
                    type: "audio",
                    mimeType: "audio/webm;codecs=pcm",
                    recorderType: RecordRTC.StereoAudioRecorder,
                    timeSlice: 250,
                    desiredSampRate: 16000,
                    numberOfAudioChannels: 1,
                    bufferSize: 16384,
                    audioBitsPerSecond: 128000,
                    ondataavailable: async (blob) => {
                        if (rt) {
                            rt.sendAudio(await blob.arrayBuffer());
                        }
                    },
                });
        
                console.log('Start talking...' + Date.now())
                recorder.startRecording();
                setLabel('LISTENING')
            })
            .catch((err) => console.error(err));
        }
        setIsRecording(!isRecording);
    }

    return (
        <div>
            <h1>Whisper Realtime Transcription</h1>
            <Button id="start" onClick={(e) => handleStartButtonClick()}>{label}</Button>
            <TextField multiline fullWidth rows={2} value={transcription} />
            <br/>    
            <br/>
            <TextField
                multiline
                fullWidth
                rows={10}
                value={editableChartText}
                disabled={!editable}
                onChange={(e) => handleChartTextEditableChange(e)} />
        </div>
    )
}

export default RealtimeScreen